// process.env.NODE_ENV is a string replaced by webpack's mode configuration value
// do not rely on process.env because this object is empty unless explicitly defined in webpack's DefinePlugin
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
